export interface HomeworkCountdownVoiceMemory {
  readonly problemKey: string | null;
  readonly lastAnnouncedSecond: number | null;
}

export interface HomeworkCountdownVoiceAdvance {
  readonly memory: HomeworkCountdownVoiceMemory;
  readonly announcement: number | null;
}

export function initialHomeworkCountdownVoiceMemory(): HomeworkCountdownVoiceMemory {
  return { problemKey: null, lastAnnouncedSecond: null };
}

export function activeHomeworkElapsedMs(
  elapsedBeforeResumeMs: number,
  resumedAtMs: number,
  nowMs: number,
  timeLimitSeconds: number,
): number {
  const limitMs = Math.max(0, timeLimitSeconds) * 1_000;
  const activeSegmentMs = Math.max(0, nowMs - resumedAtMs);
  return Math.min(limitMs, Math.max(0, elapsedBeforeResumeMs) + activeSegmentMs);
}

export function homeworkRemainingSeconds(timeLimitSeconds: number, elapsedMs: number): number {
  const remainingMs = Math.max(0, Math.max(0, timeLimitSeconds) * 1_000 - elapsedMs);
  return Math.ceil(remainingMs / 1_000);
}

export function advanceHomeworkCountdownVoice(
  previous: HomeworkCountdownVoiceMemory,
  problemKey: string,
  remainingSeconds: number,
): HomeworkCountdownVoiceAdvance {
  const countdownSecond =
    Number.isInteger(remainingSeconds) && remainingSeconds >= 0 && remainingSeconds <= 10
      ? remainingSeconds
      : null;
  const sameProblem = previous.problemKey === problemKey;
  const announcement =
    countdownSecond !== null && (!sameProblem || previous.lastAnnouncedSecond !== countdownSecond)
      ? countdownSecond
      : null;

  return {
    memory: {
      problemKey,
      lastAnnouncedSecond: countdownSecond ?? (sameProblem ? previous.lastAnnouncedSecond : null),
    },
    announcement,
  };
}
